import { render, staticRenderFns } from "./BannerPartner.vue?vue&type=template&id=696ee0c7&scoped=true"
import script from "./BannerPartner.vue?vue&type=script&lang=ts"
export * from "./BannerPartner.vue?vue&type=script&lang=ts"
import style0 from "./BannerPartner.vue?vue&type=style&index=0&id=696ee0c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696ee0c7",
  null
  
)

export default component.exports